// react
import React, { useEffect } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1,MaskOnlyNumbers} from "beaktShared/helpers/masks";

// services
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoCartao.js";
const useStyles = makeStyles(styles);

export default function PagamentoCartao({ pgto, CallloadTotalizadorPgtosCt, formasCartao }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const { register, errors, getValues, handleSubmit, setValue, clearError, setError} = useForm({mode: "onBlur"}); 

  const [gatewayCartao, setgatewayCartao] = React.useState("")  

  const [bandeira, setbandeira] = React.useState("");
  const [listSelectBandeiras, setlistSelectBandeiras] = React.useState([]);

  const [displayParcela, setdisplayParcela] = React.useState(true);
  const [displayCartaoCredito, setdisplayCartaoCredito] = React.useState(true); 
  const [displayCartaoTelefone, setdisplayCartaoTelefone] = React.useState(false);  
  const [displayCartaoOnline, setdisplayCartaoOnline] = React.useState(false);  

  useEffect(() => {  
    if(listSelectBandeiras.length === 0)
    {  LoadSelectBandeiras();  }          
   
    if (formasCartao.length === 1){  
      handleChangeTipoCartao(formasCartao[0].gateway);
    }
  }, []);

  const LoadSelectBandeiras = (s) =>{  

    const endPoint = "cartaoBandeira/"
    UseGetApiSimple(endPoint,0).then(result=>{       
        if(result.status !== 200)
        {                                     
            //showNotification(result.message,'danger');
            //return false; 
        }      
             
        if(result.data !== undefined)
          setlistSelectBandeiras(result.data);
        return true;                
    });  
};

  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });

  const [detalheParcela,setdetalheParcela]= React.useState({
    show:false,
    valorParcela:0
  });

  const handleChangeTipoCartao = (e) =>{    
    clearError("tipoCartao");

    setgatewayCartao(e);
    setValue("tipoCartao", e);
    
    setdisplayCartaoCredito(false);
    setdisplayCartaoTelefone(false);
    setdisplayCartaoOnline(false);

    if (e === "Beakt Crédito ESitef"){
      setdisplayCartaoCredito(true);
      setdisplayParcela(true);
    }
    else if (e === "Beakt Crédito Sitef"){
      setdisplayParcela(true);
    }
    else if (e === "Beakt Débito Sitef"){
      setdisplayParcela(false);
    }
    else if (e === "Telefone"){
      setdisplayCartaoTelefone(true);
      setdisplayParcela(true);
    }
    else if (e === "Link"){
      setdisplayCartaoOnline(true);
      setdisplayParcela(true);
    }
  }

  const handleChangeParcelas = (e) =>{
    let qtd = parseInt(e.target.value);
    
    if(qtd > 12){
      setmessageReturn({
        show:true,
        message:t('número máximo de parcelas é 12!')
      });
      setValue("parcelas","");
      return;
    }
    else{
      setmessageReturn({show:false})
      let valor = getValues().valor;
      calculaValorParcela(qtd,valor);
    }
  
  }

  const handleChangeValor = (e) =>{
    let valor = e.target.value;
    let qtd = parseInt(getValues().parcelas);
    calculaValorParcela(qtd,valor);
  }

  const calculaValorParcela = (qtd,valor) =>{

    if(valor === "" || valor === undefined)
    {
      setdetalheParcela({show:false,valorParcela:0})
      return;
    }
      
    if(qtd === 1)
    {   
      setdetalheParcela({show:false,valorParcela:0})
      return;
    }     

    valor = transformValueFormatedtoFloat(valor);
    if(valor === 0)
    {
      setdetalheParcela({show:false,valorParcela:0})
      return;
    }

    let valorParcela = valor / qtd;      
    setdetalheParcela({show:true,valorParcela:valorParcela})
    return;
    
  }

  const handleNomeCartao = (e) =>{    
    e.target.value = e.target.value.toUpperCase();
  }

  const [LoadingForm,setLoadingForm]= React.useState(false);
  const onSubmit = (data, e) => {
    e.preventDefault();
    
    if ((!data.tipoCartao || data.tipoCartao === 0)&&formasCartao.length>1){
      return setError("tipoCartao", "required");
    }
       
    let codBandeira = 0;
    let descBandeira = "";
    let numFinalCartao = "";

    if(displayCartaoOnline){
      if (!data.bandeira){
        return setError("bandeira", "required");
      }
    }

    if(data.parcelas == "")
      return setError("parcelas", "required");

    if(displayCartaoCredito || displayCartaoTelefone || displayCartaoOnline){
      codBandeira = getCodEsitefByIdCartaoBandeira();
      descBandeira = getDescricaobyIdCartaoBandeira();
      if(codBandeira === undefined || codBandeira === null)
      {
        setmessageReturn({
          show:true,
          message:t('error_message.select_card_flag')
        });    
        setLoadingForm(false);  
        return false;
      }
    }
     
    if (displayCartaoCredito || displayCartaoTelefone){
      if (!data.bandeira){
        return setError("bandeira", "required");
      }
      if(data.numcartao.length < 16 && data.bandeira != 5)
      {
        setmessageReturn({
          show:true,
          message:t('error_message.invalid_card_number')
        });    
        setLoadingForm(false);  
        return false;
      }

      if(data.numcartao.length < 15 && data.bandeira === 5)
      {
        setmessageReturn({
          show:true,
          message:t('error_message.invalid_card_number')
        });    
        setLoadingForm(false);  
        return false;
      }

      if(data.bandeira === 5)
        numFinalCartao = data.numcartao.substring(12,15); 
      else
        numFinalCartao = data.numcartao.substring(12,16); 
    }

    if(displayCartaoTelefone){
      if(data.numeroAutorizacao.length != 6)
      {
        setmessageReturn({
          show:true,
          message:t('error_message.invalid_authorization_number')
        });    
        setLoadingForm(false);  
        return false;
      }
      else if(data.numeroAutorizacao == "000000" || data.numeroAutorizacao == "111111" || data.numeroAutorizacao == "222222" || data.numeroAutorizacao == "333333" || data.numeroAutorizacao == "444444" || data.numeroAutorizacao == "555555" || data.numeroAutorizacao == "666666" || data.numeroAutorizacao == "777777" || data.numeroAutorizacao == "888888" || data.numeroAutorizacao == "999999"){
        setmessageReturn({
          show:true,
          message:t('error_message.invalid_authorization_number')
        });    
        setLoadingForm(false);  
        return false;
      }
    }
     
    if (displayCartaoCredito){
      if(!validateMoth(data.validademes))
      {
        setmessageReturn({
          show:true,
          message:t('error_message.invalid_month_validity')
        });    
        setLoadingForm(false);  
        return false;
      }

      let now = new Date();
      let data_cartao = new Date(parseInt("20" + data.validadeano), parseInt(data.validademes) - 1, 1);
      if (data_cartao < new Date(now.getFullYear(), now.getMonth(), 1)){
        setmessageReturn({
          show:true,
          message:t('error_message.card_expired')
        });    
        setLoadingForm(false);  
        return false;
      }
    }
    
    let valor = transformValueFormatedtoFloat(data.valor);
    if(valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2))
    {
      setmessageReturn({
        show:true,
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });    
      setLoadingForm(false);  
      return false;
    }
    
    let descParcelas = t('label.at_sight');
    if (displayParcela === true)
    {
      if(parseInt(data.parcelas) > 1)
        descParcelas = data.parcelas + "x "+transformValueFloattoFormated(detalheParcela.valorParcela);
    }
   
    let descricaoFormaPgto = formasCartao.filter(({gateway}) => gateway === gatewayCartao)[0].descricao;
    setLoadingForm(true);
    let pg = {
      id:pgto.pagamentos.length+1,
      tipo:1, //0- Dinheiro / 1-Cartão / 2-Boleto / 3-Cheque / 4-Outros
      descricaoFormaPgto: descricaoFormaPgto,
      gateway: gatewayCartao,
      valor:valor,
      descTipo: descricaoFormaPgto + (gatewayCartao === "Beakt Crédito ESitef" ? t('label.end') +" "+ numFinalCartao : ""),
      parcela:data.parcelas,
      descPacela:descParcelas,
      dadosComplementarCartao:{
        numFinalCartao: numFinalCartao,
        numCartao: data.numcartao,
        nomeCartao: data.nomecartao,
        validademes: data.validademes,
        validadeano: data.validadeano,
        cvv: data.cvv,
        codBandeiraCartao:codBandeira,
        numeroAutorizacao:data.numeroAutorizacao,
        descBandeiraCartao: descBandeira,
        codPedido: data.codPedido
      }
    }

    let updatepgto ={
      ...pgto,        
      pagamentos:[
        ...pgto.pagamentos,
        pg
      ]
    };

    clearForm();
    setmessageReturn({show:false})
    setLoadingForm(false);  
    CallloadTotalizadorPgtosCt(updatepgto);   
    return true;
  }

  const validateMoth = (m) =>{

    if (m === '01' || m === '02' || m === '03' || m === '04' || m === '05' || m === '06' ||
        m === '07' || m === '08' || m === '09' || m === '10' || m === '11' || m === '12'  )
    {
        return true;              
    }
    return false;  
  }

  const clearForm = () =>{
    setValue("numcartao","");
    setValue("nomecartao","");
    setValue("validademes","");
    setValue("validadeano","");
    setValue("cvv","");
    setValue("valor","");
    setValue("parcelas",1);
    setValue("bandeira","");
    setValue("numeroAutorizacao","");
    setValue("codPedido","");
    setbandeira("");
    setdetalheParcela({show:false,valorParcela:0})
  }

  const getCodEsitefByIdCartaoBandeira = () =>{
    var vefifyExists = listSelectBandeiras.filter(obj => {
      return obj.cartaoBandeiraId === bandeira;
    });
    if(vefifyExists[0])
      return vefifyExists[0].codigoBandeiraEsitef;  
  }

  const getDescricaobyIdCartaoBandeira = () =>{
    var vefifyExists = listSelectBandeiras.filter(obj => {
      return obj.cartaoBandeiraId === bandeira;
    });
    if(vefifyExists[0])
      return vefifyExists[0].descricao;  
  }

  const handleBandeiraChange = event => {
    let value = event
    setbandeira(value);
    setValue("bandeira", value);  
    if (value !== "") 
        clearError("bandeira");         
  }; 

return (
    <div>    
      
      <form onSubmit={handleSubmit(onSubmit)}>   

      {formasCartao.length > 1 &&
        <GridContainer className={classes.containerin}> 
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
              {t('label.card_type')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={9} md={6}>
            <div className="removeScroll">
            <Select
              styles={ValidSelect(errors.tipoCartao ? true : false)}
              classNamePrefix="select"            
              isSearchable={true}
              name="tipoCartao"
              placeholder={t('label.select')+"..."}
              options={formasCartao}        
              value={formasCartao.filter(({gateway}) => gateway === gatewayCartao)}
              getOptionLabel={({descricao}) => descricao}
              getOptionValue={({gateway}) => gateway}                
              onChange={(value) => handleChangeTipoCartao(value.gateway)}
              ref={() => register( { name: "tipoCartao" })}
            />
            </div>
            <FormHelperText className={classes.labelRootError}>            
              {errors.tipoCartao && <span className="obg"> {t('label.required')} </span>}
            </FormHelperText> 
          </GridItem>
        </GridContainer>
      }
      {(displayCartaoCredito || displayCartaoTelefone || displayCartaoOnline) &&
        <>
        <GridContainer className={classes.containerin}> 
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
            {t('label.flag')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={9} md={6}>
            <Select
              classNamePrefix="select"
              styles={ValidSelect(errors.bandeira?true:false)}
              isSearchable={true}
              name="bandeira"
              placeholder={t('label.select')+"..."}
              options={listSelectBandeiras}              
              getOptionLabel={({descricao}) => descricao}
              getOptionValue={({cartaoBandeiraId}) => cartaoBandeiraId}
              onChange={(value) => handleBandeiraChange(value.cartaoBandeiraId !== null ? value.cartaoBandeiraId : "") }              
              ref={() => register(
                  { name: "bandeira" },
                  { required: false })
              }
            />
            <FormHelperText className={classes.labelRootError}>
              {errors.bandeira && <span className="obg">{t('label.required')}</span>}
            </FormHelperText> 
          </GridItem>
        </GridContainer>   
        </>
      }   
      {(displayCartaoCredito || displayCartaoTelefone) &&
        <>
        <GridContainer className={classes.containerin}> 
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
            {t('label.card_number')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={9} md={6}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue=""  
                  name="numcartao"      
                  inputProps={{maxLength: 16}}   
                  onInput={(e) => MaskOnlyNumbers(e) }             
                  inputRef={register({required: (displayCartaoCredito || displayCartaoTelefone) === true ? true : false})}
                  error={errors.numcartao?true:false} 
              />
              <FormHelperText>
                  {errors.numcartao && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>
        </GridContainer>
        </>
      }
  
     
      {displayCartaoOnline &&
        <>
          <GridContainer className={classes.containerin}> 
            <GridItem xs={12} sm={3} md={4}>
              <div className={classes.labelIdent}>
              {t('sidebar.order_code')} *
              </div>
            </GridItem>
            <GridItem xs={12} sm={9} md={6}>
                <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{shrink: true}} 
                    defaultValue=""  
                    name="codPedido"      
                    inputProps={{maxLength: 50}}   
                    // onInput={(e) => MaskOnlyNumbers(e) }             
                    inputRef={register({required: displayCartaoOnline === true ? true : false})}
                    error={errors.codPedido?true:false} 
                />
                <FormHelperText>
                    {errors.codPedido && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>   
            </GridItem>
          </GridContainer>
        </>
      }
      {(displayCartaoCredito) &&
      <>
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
            {t('label.card_name')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={9} md={6}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue=""  
                  name="nomecartao" 
                  onChange={(e) => handleNomeCartao(e)}  
                  inputProps={{maxLength: 30}}              
                  inputRef={register({required: displayCartaoCredito})}
                  error={errors.nomecartao?true:false} 
              />
              <FormHelperText>
                  {errors.nomecartao && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>
        </GridContainer>
            
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
            {t('label.validity')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={4} md={3}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue="" 
                  placeholder={t('label.month')}    
                  name="validademes"   
                  inputProps={{maxLength: 2}}   
                  onInput={(e) => MaskOnlyNumbers(e) }                
                  inputRef={register({required: displayCartaoCredito})}
                  error={errors.validademes?true:false} 
              />
              <FormHelperText>
                  {errors.validademes && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>
          <GridItem xs={12} sm={4} md={3}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue="" 
                  placeholder={t('label.year')}  
                  name="validadeano"   
                  inputProps={{maxLength: 2}}   
                  onInput={(e) => MaskOnlyNumbers(e) }                
                  inputRef={register({required: displayCartaoCredito})}
                  error={errors.validadeano?true:false} 
              />
              <FormHelperText>
                  {errors.validadeano && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>
        </GridContainer>  
               
        <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={3} md={4}>
          <div className={classes.labelIdent}>
          {t('label.cvv')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={3} md={2}>
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue="" 
                name="cvv"       
                inputProps={{maxLength: 4}}   
                onInput={(e) => MaskOnlyNumbers(e) }               
                inputRef={register({required: displayCartaoCredito})}
                error={errors.cvv?true:false} 
            />
            <FormHelperText>
                {errors.cvv && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>        
      </GridContainer>   
      </>
      }
       
      {displayCartaoTelefone && 
        <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
              Nº {t('label.authorization')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={3} md={6}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue="" 
                  name="numeroAutorizacao"       
                  inputProps={{maxLength: 10}}             
                  inputRef={register({required: displayCartaoTelefone})}
                  error={errors.numeroAutorizacao?true:false} 
              />
              <FormHelperText>
                  {errors.numeroAutorizacao && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>        
        </GridContainer> 
      }

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={3} md={4}>
          <div className={classes.labelIdent}>
          {t('label.value')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={4} md={3}>  
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue=""  
                name="valor"        
                onChange={(e) => handleChangeValor(e)}          
                InputProps={{ inputComponent: MaskMoney}}    
                inputRef={register({required: true})}
                error={errors.valor?true:false} 
            />
            <FormHelperText>
                {errors.valor && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>
      </GridContainer>

      {displayParcela && 
        <>       
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
            {t('label.parcel_in')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={3} md={2}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  name="parcelas"                  
                  defaultValue={1}      
                  type="number"     
                  onChange={(e) => handleChangeParcelas(e)}                                               
                  inputProps={{maxLength: 2}} 
                  onInput={(e) => MaskOnlyNumbersStart1(e) }          
                  inputRef={register({required: displayParcela})}
                  error={errors.parcelas?true:false} 
              />
              <FormHelperText>
                  {errors.parcelas && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>   
          <GridItem xs={12} sm={5} md={5}>
            <br/>
            <small>({t('information_message.inform_the_number_of_parcels')})</small>
          </GridItem>       
        </GridContainer> 
     
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>       
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            {detalheParcela.show &&
              <div><div className={classes.boxTotalParcela}>
                <label className={classes.boxValueParcela}>
                {t('label.parcel_value')}: {t('label.money_symbol')} {transformValueFloattoFormated(detalheParcela.valorParcela)}
                </label> 
              </div><br/></div>
            }
          </GridItem>       
        </GridContainer>  
        </>
      }

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={12} md={12}>
          {messageReturn.show &&
            <div><div className="alertErrorEx alertmax">
              <p>
              {messageReturn.message}   
              </p>
            </div><br/></div>
          }
            <center>
            {displayParcela === true &&
                <span className={classes.boxTotalPagamentoCt}>
                {t('label.total')} {t('label.money_symbol')} {transformValueFloattoFormated((getValues().valor === undefined || getValues().valor === "") ? 0 : getValues().valor)}                
                </span>
            }
            <Button type="submit" color="primary" >
            {t('button.post_payment')}                     
            </Button>
            {LoadingForm && <CircularProgress />}
            </center>
        </GridItem>
      </GridContainer>
      </form>

    </div>
);
}